export const tabsMixin = {
  data() {
    return {
      activeTab: 0
    };
  },

  created() {
    // If accessing a tabs child route directly via the URL path
    // then we check the matched routes to
    // find if the tab routeName exists
    // so that the correct tab is highlighted for the current path
    let matchedRoute = this.$route.matched.find(matchedRoute => {
      return this.tabs.some(tab => tab.routeName === matchedRoute.name);
    });
    let routeName = this._.get(matchedRoute, "name", "");

    this.activeTab =
      this.tabs.map(tab => tab.routeName).indexOf(routeName) || 0;
  },

  methods: {
    updateRoute(activeTab) {
      this.$router.push({ name: this.tabs[activeTab].routeName });
    }
  }
};
